<template>
<div>
    <!--
    <vlt-button label="Bump" secondary app @click="bump" />
    <br>
    -->
    <div id="session" @error="errorHandler">
        <publisher :session="session" @error="errorHandler" :opts="opts" @publisherConnected="doStart"></publisher>
        <div id="subscribers" v-for="stream in streams" :key="stream.streamId">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <subscriber @error="errorHandler" :stream="stream" :session="session" :opts="sopts"></subscriber>
        </div>
    </div>
</div>
</template>

<script>
import OT from "@opentok/client";
import Publisher from "./Publisher.vue";
import Subscriber from "./Subscriber.vue";
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput
} from "@vonagevolta/vue";

const errorHandler = err => {
    alert(err.message);
};

export default {
    name: "session",
    components: {
        Publisher,
        Subscriber,
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput
    },
    props: {
        sessionId: {
            type: String,
            required: true
        },
        token: {
            type: String,
            required: true
        },
        apiKey: {
            type: String,
            required: true
        }
    },
    created() {
        this.session = OT.initSession(this.apiKey, this.sessionId);
        this.session.connect(this.token, err => {
            if (err) {
                errorHandler(err);
            }
        });
        console.log("Session: ", this.session);
        this.session.on("streamCreated", event => {
            this.streams.push(event.stream);
        });
        this.session.on("streamDestroyed", event => {
            const idx = this.streams.indexOf(event.stream);
            if (idx > -1) {
                this.streams.splice(idx, 1);
            }
        });
        this.$emit("gotSession",this.session);
        this.getRate();
    },
    data() {
        return {
            interval: {},
            streams: [],
            session: null,
            opts: {
                width: 640,
                height: 480
            },
            sopts: {
                width: 400,
                height: 300
            },
            publisher: {},
        };
    },
    methods: {
        errorHandler,
        doStart(publisher) {
            console.log("Emitted publisher: ", publisher);
            this.publisher = publisher;
            this.$emit("gotPublisher", publisher);
        },
        bump() {
            OT.subscribers.forEach(e => {
                console.log("Bumping id " + e.id);
                e.setPreferredResolution({
                    'width': 1280,
                    'height': 720
                });
            })
        },
        getRate() {
            var newThis = this;
            console.log("Getting rate.");
            this.interval = setInterval(function () {
                if (OT.subscribers.length) {
                    OT.subscribers.forEach(e => {
                        var rateh = e.videoHeight();
                        var ratew = e.videoWidth();
                        e.getStats(
                            (error, stats) => {
                                console.error("Video " + e.id + " at " + rateh + "," + ratew + ": ", stats.video);
                            }
                        );
                    })
                } else {
                    console.log("Removing subscriber interval");
                    clearInterval(newThis.interval);
                }
            }, 5000);
        }
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        console.log("Disconnecting OT Session");
        if (this.session.connection) {
            //this.session.forceDisconnect(this.session.connection)
        }
        this.session.disconnect();
    }
};
</script>

<style>
.OT_subscriber {
    float: left;
}

.OT_publisher {
    float: left;
}
</style>
